import { apiFetch } from "./api";

export const saveEditPendings = async (values) => {
    const obj = {
        method: 'POST',
        body: {
            pendings: values,
            option: 'save_edit_pending',
        }
    }

    const response = await apiFetch(obj);

    return response;
};
